import { render, staticRenderFns } from "./SmAvatar.vue?vue&type=template&id=eeca7992&scoped=true&"
import script from "./SmAvatar.vue?vue&type=script&lang=ts&"
export * from "./SmAvatar.vue?vue&type=script&lang=ts&"
import style0 from "./SmAvatar.vue?vue&type=style&index=0&id=eeca7992&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eeca7992",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VAvatar,VImg})
